/**
 * Builds the `codes` filter for the product list endpoints. "Code type" and
 * "Code value" are independent filter defs, so either may be applied alone —
 * the backend accepts a partial `codes` object and requires only one of them.
 */
export function buildCodesFilter(
  filters: Record<string, string[]>,
): { codeId?: string; codeValue?: string } | undefined {
  const codeId = filters.codeId?.[0];
  const codeValue = filters.codeValue?.[0];

  const codes = {
    ...(codeId ? { codeId } : {}),
    ...(codeValue ? { codeValue } : {}),
  };

  return Object.keys(codes).length > 0 ? codes : undefined;
}
